// STYLE_CATALOG do edvid (app.js ~88) — o único lugar que sabe quais looks a Fase 2
// sabe montar. Ids iguais ao contrato (types/videoEdit.ts) e ao render.
import type { CaptionStyleId, EditStyleId, HeadlineStyleId, StyleElements, StyleSetup } from '../../../types/videoEdit';
import { DEFAULT_STYLE } from '../../../types/videoEdit';

const PILL = 'rgba(129,140,248,.7)';
const PILL_FILL = 'rgba(129,140,248,.95)';
const IMG = 'rgba(251,146,60,';

const pill = (y: number) => `
  <rect x="12" y="${y}" width="42" height="11" rx="5.5" fill="#0b1020" stroke="${PILL}"/>
  <rect x="16" y="${y + 4.5}" width="12" height="2.4" rx="1.2" fill="${PILL_FILL}"/>
  <rect x="30" y="${y + 4.5}" width="8" height="2.4" rx="1.2" fill="rgba(255,255,255,.5)"/>
  <rect x="40" y="${y + 4.5}" width="10" height="2.4" rx="1.2" fill="rgba(255,255,255,.5)"/>`;

export const EDIT_OPTIONS: Array<{ id: EditStyleId; name: string; mock: string }> = [
  {
    id: 'limpa',
    name: 'Limpa',
    mock: `<svg viewBox="0 0 66 118" xmlns="http://www.w3.org/2000/svg">
      <rect x=".5" y=".5" width="65" height="117" rx="7" fill="#070b14" stroke="rgba(255,255,255,.12)"/>
      <rect x="3" y="3" width="60" height="112" rx="5" fill="rgba(255,255,255,.05)"/>
      <circle cx="33" cy="48" r="13" fill="rgba(255,255,255,.16)"/>
      <path d="M12 115a21 21 0 0142 0z" fill="rgba(255,255,255,.16)"/>
      <rect x="14" y="14" width="38" height="4.4" rx="2.2" fill="rgba(255,255,255,.5)"/>
      <rect x="20" y="21.5" width="26" height="4.4" rx="2.2" fill="rgba(255,255,255,.3)"/>${pill(74)}
    </svg>`,
  },
  {
    id: 'split',
    name: 'Tela dividida',
    mock: `<svg viewBox="0 0 66 118" xmlns="http://www.w3.org/2000/svg">
      <rect x=".5" y=".5" width="65" height="117" rx="7" fill="#070b14" stroke="rgba(255,255,255,.12)"/>
      <rect x="3" y="3" width="60" height="36" rx="5" fill="${IMG}.16)"/>
      <circle cx="17" cy="15" r="3.6" fill="${IMG}.6)"/>
      <path d="M6 36l11-11a2 2 0 013 0l7 7 5-4a2 2 0 013 0l11 8" fill="none" stroke="${IMG}.6)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M3 40.5h60" stroke="rgba(255,255,255,.5)" stroke-width="1.2"/>
      <rect x="3" y="42" width="60" height="73" rx="5" fill="rgba(255,255,255,.05)"/>
      <circle cx="33" cy="70" r="12" fill="rgba(255,255,255,.16)"/>
      <path d="M15 115a18 18 0 0136 0z" fill="rgba(255,255,255,.16)"/>${pill(35)}
    </svg>`,
  },
  {
    id: 'split2',
    name: 'Tela dividida 2',
    mock: `<svg viewBox="0 0 66 118" xmlns="http://www.w3.org/2000/svg">
      <rect x=".5" y=".5" width="65" height="117" rx="7" fill="#070b14" stroke="rgba(255,255,255,.12)"/>
      <rect x="3" y="3" width="60" height="65" rx="5" fill="rgba(255,255,255,.05)"/>
      <circle cx="33" cy="24" r="11" fill="rgba(255,255,255,.16)"/>
      <path d="M16 68a17 17 0 0134 0z" fill="rgba(255,255,255,.16)"/>
      <path d="M3 69.5h60" stroke="rgba(255,255,255,.5)" stroke-width="1.2"/>
      <rect x="3" y="71" width="60" height="44" rx="5" fill="${IMG}.16)"/>
      <circle cx="17" cy="83" r="3.6" fill="${IMG}.6)"/>
      <path d="M6 111l11-11a2 2 0 013 0l7 7 5-4a2 2 0 013 0l11 8" fill="none" stroke="${IMG}.6)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>${pill(58)}
    </svg>`,
  },
];

// ─── Imagens geradas por IA (substitui "Tipo de edição") ───
// O usuário escolhe QUANTAS; a IA decide, imagem por imagem, se ela entra atrás da
// pessoa (card entre o fundo e a pessoa recortada) ou em tela dividida (em cima/embaixo).
export const IMAGE_COUNT_MAX = 8;
/** creditPricing.video_image_insert — cobrado só pelas imagens que entram no vídeo */
/** fallback do preço por imagem entregue; o valor efetivo vem de GET /credits/pricing (override do superadmin) */
export const IMAGE_CREDIT_COST = 0.1;

export const IMAGE_LAYOUTS: Array<{ id: 'behind' | 'split'; name: string; hint: string; mock: string }> = [
  {
    id: 'behind',
    name: 'Atrás de você',
    hint: 'card entre o fundo e você recortado — acento curto na palavra',
    mock: `<svg viewBox="0 0 66 118" xmlns="http://www.w3.org/2000/svg">
      <rect x=".5" y=".5" width="65" height="117" rx="7" fill="#070b14" stroke="rgba(255,255,255,.12)"/>
      <rect x="3" y="3" width="60" height="112" rx="5" fill="rgba(255,255,255,.05)"/>
      <rect x="7" y="8" width="52" height="64" rx="5" fill="${IMG}.2)" stroke="${IMG}.55)"/>
      <circle cx="18" cy="19" r="3.6" fill="${IMG}.6)"/>
      <path d="M9 50l12-12a2 2 0 013 0l8 8 6-5a2 2 0 013 0l16 12" fill="none" stroke="${IMG}.6)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <circle cx="33" cy="58" r="13" fill="#3b4256" stroke="rgba(255,255,255,.35)"/>
      <path d="M11 115a22 22 0 0144 0z" fill="#3b4256" stroke="rgba(255,255,255,.35)"/>${pill(92)}
    </svg>`,
  },
  {
    id: 'split',
    name: 'Tela dividida',
    hint: 'faixa grande em cima ou embaixo — quando a imagem precisa ser lida',
    mock: EDIT_OPTIONS.find(o => o.id === 'split')!.mock,
  },
];

export const HEADLINE_OPTIONS: Array<{ id: HeadlineStyleId; name: string }> = [
  { id: 'outline', name: 'Contorno' },
  { id: 'card', name: 'Cartão' },
  { id: 'realce', name: 'Realce' },
  { id: 'misto', name: 'Misto' },
  { id: 'empilhado', name: 'Empilhado' },
  { id: 'pergunta', name: 'Caixinha de pergunta' },
  { id: 'none', name: 'Nenhum' },
];

export const CAPTION_OPTIONS: Array<{ id: CaptionStyleId; name: string }> = [
  { id: 'karaoke', name: 'Karaokê' },
  { id: 'stacked', name: 'Empilhado' },
  { id: 'scatter', name: 'Disperso' },
  { id: 'simples', name: 'Simples' },
  { id: 'serifada', name: 'Serifada' },
  { id: 'classica', name: 'Clássica' },
  { id: 'none', name: 'Nenhuma' },
];

export const ELEMENT_OPTIONS: Array<{ id: keyof StyleElements; name: string; hint: string; icon: string }> = [
  {
    id: 'tracking', name: 'Movimento de tracking', hint: 'o enquadramento segue o rosto',
    icon: '<svg viewBox="0 0 16 16" fill="currentColor"><path d="M2 5.6V3.4A1.4 1.4 0 013.4 2h2.2M10.4 2h2.2A1.4 1.4 0 0114 3.4v2.2M14 10.4v2.2a1.4 1.4 0 01-1.4 1.4h-2.2M5.6 14H3.4A1.4 1.4 0 012 12.6v-2.2" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><circle cx="8" cy="8" r="2.1"/></svg>',
  },
  {
    id: 'zoomAuto', name: 'Automação de zoom in', hint: 'push-in lento dentro de cada trecho',
    icon: '<svg viewBox="0 0 16 16"><circle cx="7" cy="7" r="4.6" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M10.6 10.6L14 14" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" fill="none"/><path d="M7 5.1v3.8M5.1 7h3.8" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" fill="none"/></svg>',
  },
  {
    id: 'zoomCuts', name: 'Zoom in e out nos cortes', hint: 'salto seco de plano na emenda',
    icon: '<svg viewBox="0 0 16 16"><rect x="1.2" y="3.4" width="6" height="9.2" rx="1.6" fill="none" stroke="currentColor" stroke-width="1.4"/><rect x="9.6" y="1.9" width="5.2" height="12.2" rx="1.6" fill="none" stroke="currentColor" stroke-width="1.4"/><path d="M8.4 8h.7" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>',
  },
  {
    id: 'flashCut', name: 'Flash na transição', hint: 'flash + clique nas trocas de layout',
    icon: '<svg viewBox="0 0 16 16"><path d="M3 13.2L13 3.2" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" fill="none"/><path d="M6.6 14L9.4 11.2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" fill="none" opacity=".55"/><path d="M6.6 4.8L3.8 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" fill="none" opacity=".55"/></svg>',
  },
  {
    id: 'music', name: 'Música do Instagram na publicação', hint: 'anexada ao Reel ao publicar, não entra no MP4',
    icon: '<svg viewBox="0 0 16 16" fill="currentColor"><path d="M12.6 1.6L6.9 3a.7.7 0 00-.55.68v5.6a2 2 0 101.35 1.9V5.9l4.4-1.05v2.9a2 2 0 101.35 1.9V2.3a.7.7 0 00-.85-.7z"/></svg>',
  },
];

/** Quem pinta com a cor de destaque (espelho do template): com karaokê + contorno nada usa a cor. */
export const ACCENT_USERS = { headlines: ['realce', 'misto', 'empilhado'] as HeadlineStyleId[], captions: ['stacked'] as CaptionStyleId[] };

export const INTEGRAIA_ACCENT = '#6366f1'; // indigo-500 da marca
/** Swatches: marca do cliente primeiro, IntegraIA, depois as do edvid. */
export const ACCENT_SWATCHES = ['#ff5200', '#facc15', '#22c55e', '#06b6d4', '#ec4899', '#ffffff'];

export function styleName(group: 'edit' | 'headline' | 'captions', id: string): string {
  const list = group === 'edit' ? EDIT_OPTIONS : group === 'headline' ? HEADLINE_OPTIONS : CAPTION_OPTIONS;
  return list.find(o => o.id === id)?.name || '—';
}

export function accentWhere(style: StyleSetup): string[] {
  return [
    ACCENT_USERS.headlines.includes(style.headline) && 'na headline',
    ACCENT_USERS.captions.includes(style.captions) && 'na legenda',
  ].filter(Boolean) as string[];
}

export function styleSummary(style: StyleSetup): string {
  const on = ELEMENT_OPTIONS.filter(e => style.elements[e.id]);
  const where = accentWhere(style);
  const n = style.imageCount ?? 0;
  return `${n ? `${n} imagem${n > 1 ? 'ns' : ''} por IA` : 'sem imagens'} · headline ${styleName('headline', style.headline)} · legenda ${styleName('captions', style.captions)}`
    + (where.length ? ` · destaque ${style.accent.toUpperCase()}` : '')
    + ` · ${on.length ? on.map(e => e.name).join(', ') : 'sem elementos extras'}`;
}

export function initialStyle(fromJob: StyleSetup | null | undefined, brandAccent?: string | null): StyleSetup {
  const base: StyleSetup = { ...DEFAULT_STYLE, accent: brandAccent || DEFAULT_STYLE.accent, elements: { ...DEFAULT_STYLE.elements }, imageCount: 0 };
  if (!fromJob) return base;
  // estilo salvo antes da quantidade de imagens: tela dividida vira 3 imagens (a IA decide o layout)
  const imageCount = clampImageCount(fromJob.imageCount ?? (fromJob.edit && fromJob.edit !== 'limpa' ? 3 : 0));
  return { ...base, ...fromJob, imageCount, elements: { ...base.elements, ...(fromJob.elements || {}) } };
}

export function clampImageCount(n: unknown): number {
  const v = Math.floor(Number(n) || 0);
  return Math.max(0, Math.min(IMAGE_COUNT_MAX, v));
}
